export default __webpack_public_path__ + "static/media/ingest-report.333f4d9d.png";